import React from 'react'

export default function TransitionContainer({ children }) {
  const childrenArray = React.Children.toArray(children)
  return childrenArray[0] || null
}


// WEBPACK FOOTER //
// /opt/build/repo/src/components/common/TransitionContainer.js